import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  UserIdentificationData,
  UserIdentificationEntity,
  UserIdentificationError,
  UserIdentificationExistingCartPayload,
  UserIdentificationPayload,
} from ".";
import {
  UserIdentificationMaybeExistingCartPayload,
  UserIdentificationV2Payload,
} from "./userIdentificationInterfaces";

import { PostalAddressDto } from "Store/interfaces/PostalAddressDto";
import { isDefined } from "Utils/functions";

const initialState: UserIdentificationEntity = {
  current: null,
  isLoading: false,
  error: null,
};

const userIdentificationSlice = createSlice({
  name: "userIdentification",
  initialState,
  reducers: {
    resetUserIdentification: (state) => {
      state.current = null;
      state.isLoading = false;
      state.error = null;
    },

    userIdentificationCheckExistingCartStart: (
      state,
      _action: PayloadAction<UserIdentificationMaybeExistingCartPayload>,
    ) => {
      state.isLoading = true;
    },

    userIdentificationStart: (
      state,
      _action: PayloadAction<UserIdentificationPayload>,
    ) => {
      state.isLoading = true;
    },

    userIdentificationV2Start: (
      state,
      _action: PayloadAction<UserIdentificationV2Payload>,
    ) => {
      state.isLoading = true;
    },

    userIdentificationExistingCartStart: (
      state,
      _action: PayloadAction<UserIdentificationExistingCartPayload>,
    ) => {
      state.isLoading = true;
    },

    userIdentificationSucceeded: (
      state,
      action: PayloadAction<UserIdentificationData>,
    ) => {
      state.current = {
        ...state.current,
        ...action.payload,
      };
      state.isLoading = false;
    },

    userIdentificationV2Succeeded: (
      state,
      action: PayloadAction<PostalAddressDto>,
    ) => {
      if (
        isDefined(state.current) &&
        isDefined(state.current.newCustomerResponse)
      ) {
        state.current.newCustomerResponse = {
          ...state.current.newCustomerResponse,
          providedContactInfo: {
            address: action.payload,
          },
        };
      }
      state.isLoading = false;
    },

    operationFailed: (
      state,
      action: PayloadAction<UserIdentificationError>,
    ) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  userIdentificationStart,
  userIdentificationV2Start,
  userIdentificationExistingCartStart,
  userIdentificationCheckExistingCartStart,
  userIdentificationSucceeded,
  userIdentificationV2Succeeded,
  operationFailed,
  resetUserIdentification,
} = userIdentificationSlice.actions;
export const userIdentification = userIdentificationSlice.reducer;
